import { SVGProps } from "react";

const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "14"}
    height={props.height || "8"}
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.75 0.750046C12.75 0.750046 8.33107 6.74999 6.74995 6.75C5.16884 6.75001 0.75 0.75 0.75 0.75"
      stroke={props.color ? props.color : "#AFAFAE"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ChevronDown;
